const initialState = {
	askInfos: true,
	mail: null,
	language: null
}

export default (state = initialState, action) => {
	switch (action.type) {
		case 'SET_ASK_INFOS':
			return {
				...state,
				askInfos: action.payload
			}
		case 'SET_USER_MAIL':
			return {
				...state,
				mail: action.payload
			}
		case 'SET_USER_LANGUAGE':
			return {
				...state,
				language: action.payload
			}
		default:
			return state
	}
}
